// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import sportIcon from "@/assets/icons/aop/sport.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type SportIconProps = Omit<IconProps, "name">;

export function SportIcon(props: SportIconProps): React.ReactNode {
  return <Icon name={sportIcon} {...props} />;
}
